import { useEffect } from 'react'
import { useForm, useWatch } from 'react-hook-form'
import { useDebounce } from '@node-space/hooks'
import { useRewardsSheetContext } from '../context/RewardsSheetProvider'
import { RewardFormValues } from '../types'

const DEFAULT_FORM_VALUES: RewardFormValues = {
  currency: '',
  amount: 100000,
}

// Only allows digits 0-9, no decimals or special characters
const NUMERIC_INPUT_REGEX = /^[0-9]*$/

export const useRewardsForm = () => {
  const { rewardsProducts } = useRewardsSheetContext()
  const { control, register, setValue } = useForm<RewardFormValues>({
    defaultValues: DEFAULT_FORM_VALUES,
  })

  useEffect(() => {
    if (rewardsProducts?.length > 0) {
      setValue('currency', rewardsProducts[0]?.currency || '', { shouldValidate: true })
    }
  }, [rewardsProducts])

  const formValues = useWatch({ control })
  const selectedCurrency = formValues.currency
  const amount = formValues.amount

  const debouncedAmount = useDebounce(amount, 500)

  const onAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    // Only allow digits 0-9
    if (NUMERIC_INPUT_REGEX.test(value)) {
      setValue('amount', value === '' ? 0 : Number(value))
    }
  }

  const onCurrencyChange = (value: string) => {
    setValue('currency', value)
  }

  return {
    formValues,
    register,
    selectedCurrency,
    amount: debouncedAmount,
    rawAmount: amount,
    onAmountChange,
    onCurrencyChange,
  }
}
